let historic = {
  title: 'Histórico',
  icon: 'mdi-equalizer',
  stats: {
    title: 'Estatísticas'
  },
  filters: {
    title: 'Filtros',
    clear: 'Limpar Filtros',
    date_range: {
      title: 'Intervalo de Datas',
      date: 'Data',
      start: 'Início',
      end: 'Fim',
      presets: {
        all: 'Todas',
        this_month: 'Esse Mês',
        this_year: 'Esse Ano',
        last_year: 'Ano Passado',
        today: 'Hoje',
        yesterday: 'Ontem',
        week: 'Última Semana',
        month: 'Últimos 30 Dias',
        bimonthly: 'Últimos 60 Dias',
        quarterly: 'Últimos 90 Dias',
        year: 'Últimos 360 Dias'
      }
    },
    type: {
      title: 'Tipo'
    },
    payment: {
      title: 'Pagamento',
      methods: 'Formas de Pagamento',
      money: 'Dinheiro',
      debit: 'Débito',
      credit: 'Crédito'
    },
    status: {
      title: 'Estado',
      enabled: 'Ativo',
      disabled: 'Desativado'
    },
    customers: {
      title: 'Clientes'
    },
    addresses: {
      title: 'Endereços'
    },
    order: {
      title: 'Venda',
      operation: {
        title: 'Operação',
        categories: 'Por Categoria(s)',
        or: 'Que contenha algum:',
        and: 'Que contenha todos:'
      }
    },
    categories: {
      title: 'Categorias'
    },
    price_range: {
      title: 'Intervalo de Preços',
      min: 'Preço Mínimo',
      max: 'Preço Máximo',
      errors: {
        negative_min: 'Valor mínimo deve ser maior que zero',
        negative_max: 'Valor máximo deve ser maior que zero',
        invalid_min: 'Valor mínimo deve ser menor que o valor máximo',
        invalid_max: 'Valor máximo deve ser maior que o valor mínimo'
      }
    },
    phones: {
      title: 'Telefone'
    },
    identities: {
      title: 'CPF'
    },
    reset: 'Limpar',
    apply: 'Aplicar'
  }
}

export default historic
